import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ConditionViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ConditionViewPage extends Component<ConditionViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.condition.view }}
                pages={{
                    entity: InferenceEntities.condition(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}